export const TitleAndSubtitle = ({ title, subtitle }: { title: string, subtitle: string }) => {
    return (
        <div className='flex flex-col gap-3'>
            <h2 className='text-osBlack text-2xl font-semibold'>{title}</h2>
            <p className='text-osGrey-2'>{subtitle}</p>
        </div>
    );
};